import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const HeadingWrapper = styled.div`
  ${({ theme, displayStyles }) =>
    renderStyledElementStyles(theme, displayStyles.elements.heading)}
  ${({ theme, visualStyles }) =>
    renderStyledElementStyles(theme, visualStyles.elements.heading)}
`;
